// extracted by mini-css-extract-plugin
export default {"header":"AutoI_header__VKclu","row":"AutoI_row__8C7zq","column":"AutoI_column__r4Iv9"};